import { isMobile } from "react-device-detect";

const WRAPPER_ID = "vlibras-access-wrapper";
const WIDGET_ID = "vlibras";
const PLUGIN_SCRIPT_URL = "https://vlibras.gov.br/app/vlibras-plugin.js";

function injectVlibrasWidget() {
  const wrapper = document.getElementById(WRAPPER_ID);
  if (!wrapper || document.getElementById(WIDGET_ID)) return;

  wrapper.innerHTML = `
    <div id="${WIDGET_ID}" vw class="enabled">
      <div vw-access-button class="active"></div>
      <div vw-plugin-wrapper>
        <div class="vw-plugin-top-wrapper"></div>
      </div>
    </div>
  `;

  const script = document.createElement("script");
  script.src = PLUGIN_SCRIPT_URL;
  script.onload = () => {
    new window.VLibras.Widget("https://vlibras.gov.br/app");
  };
  wrapper.appendChild(script);
}

function removeVlibrasWidget() {
  const wrapper = document.getElementById(WRAPPER_ID);
  if (wrapper) {
    wrapper.innerHTML = "";
  }
}

export function updateVlibrasVisibility(config, { respectMobile = false } = {}) {
  const vlibras = config.find((item) => {
    return item.codeScreen === "USE-VLIBRAS";
  });

  const shouldShow = respectMobile ? !!vlibras && !isMobile : !!vlibras;

  if (shouldShow) {
    injectVlibrasWidget();
  } else {
    removeVlibrasWidget();
  }
}
